import { Box, Card, CardContent, Typography } from '@mui/material'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

export let QuickAccessBanner = ({
  title,
  description,
  onClick,
  gradient,
  backgroundImage,
}: {
  title?: string
  description?: string
  image?: string
  onClick: () => void
  gradient?: string
  backgroundImage?: string
}) => (
  <Card
    sx={{
      cursor: 'pointer',
      transition: 'transform 0.3s ease',
      '&:hover': {
        transform: 'scale(1.02)',
      },
      background: backgroundImage
        ? `url(${backgroundImage})`
        : gradient ||
          'linear-gradient(135deg, rgba(66,165,245,0.2) 0%, rgba(30,136,229,0.2) 100%)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      border: '1px solid rgba(255,255,255,0.1)',
      minHeight: 120,
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 2,
    }}
    onClick={onClick}
  >
    {title && description && backgroundImage && (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.6) 100%)',
        }}
      />
    )}
    <CardContent
      sx={{
        p: 3,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            mb: 1,
            color: 'white',
          }}
        >
          {title ?? ''}
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.9)' }} variant="body2">
          {description ?? ''}
        </Typography>
      </Box>
      {title && description && (
        <PlayArrowIcon
          sx={{ fontSize: 40, color: 'rgba(255,255,255,0.8)', ml: 2 }}
        />
      )}
    </CardContent>
  </Card>
)
